import React from 'react';
import { Tag, Tooltip } from 'antd';

/**
 * StatusTag Component
 * Provides a consistent "Soft Tag" style for status indicators across the app.
 * 
 * @param {Object} props
 * @param {string} props.status - The status text
 * @param {string} props.tooltip - Optional custom tooltip text
 * @param {Object} props.style - Optional additional styles
 */
const StatusTag = ({ status, tooltip, style: customStyle }) => {
  if (!status) return null;

  const statusConfigs = {
    // Standard statuses
    Nuevo: { bg: '#e6f7ff', text: '#1890ff', border: '#91d5ff', tip: 'Registro recién creado' },
    'En curso': { bg: '#fff7e6', text: '#fa8c16', border: '#ffd591', tip: 'En proceso de edición' },
    Pendiente: { bg: '#fff7e6', text: '#fa8c16', border: '#ffd591', tip: 'En espera de completarse' },
    Completo: { bg: '#f6ffed', text: '#52c41a', border: '#b7eb8f', tip: 'Proceso finalizado correctamente' },
    Listo: { bg: '#f6ffed', text: '#52c41a', border: '#b7eb8f', tip: 'Información técnica verificada y lista' },

    // Engineering/Process specific
    PCP: { bg: '#e6f7ff', text: '#1890ff', border: '#91d5ff', tip: 'Programación y Control de la Producción' },
    Despachado: { bg: '#f6ffed', text: '#52c41a', border: '#b7eb8f', tip: 'Item enviado a su destino' },
    Liquidado: { bg: '#fcffe6', text: '#7cb305', border: '#eaff8f', tip: 'Proceso comercial cerrado por completo' },
    Acabado: { bg: '#e6fffb', text: '#13c2c2', border: '#87e8de', tip: 'Proceso de acabado finalizado' },
    Almacen: { bg: '#fff7e6', text: '#fa8c16', border: '#ffd591', tip: 'Item ubicado en almacén' },
    Tejeduria: { bg: '#fff0f6', text: '#eb2f96', border: '#ffadd2', tip: 'Proceso de tejido en curso o finalizado' },
    Tintoreria: { bg: '#f9f0ff', text: '#722ed1', border: '#d3adf7', tip: 'Proceso de teñido en curso o finalizado' },
    Compras: { bg: '#e6f7ff', text: '#1890ff', border: '#91d5ff', tip: 'Gestión de insumos y materias primas' },
    Rotulado: { bg: '#fffbe6', text: '#faad14', border: '#ffe58f', tip: 'Identificación y etiquetado' }
  };

  const config = statusConfigs[status] || { ...statusConfigs.Pendiente, tip: '' };
  const displayTooltip = tooltip || config.tip;

  const tagNode = (
    <Tag
      style={{
        fontWeight: "600",
        borderRadius: "4px",
        backgroundColor: config.bg,
        color: config.text,
        borderColor: config.border,
        fontSize: '11px',
        cursor: displayTooltip ? 'help' : 'default',
        ...customStyle
      }}
    >
      {status.toUpperCase()}
    </Tag>
  );

  return displayTooltip ? (
    <Tooltip title={displayTooltip}>
      {tagNode}
    </Tooltip>
  ) : tagNode;
};

export default StatusTag;
